import React, { Component, createRef, forwardRef, useImperativeHandle } from "react";
import { View, Image, TextInput, Text, FlatList, ActivityIndicator} from "react-native-web";
import { ParallaxProvider, ParallaxBanner, Parallax } from 'react-scroll-parallax';
import { AnimatePresence, motion, useScroll, useTransform, useMotionValue } from 'framer-motion';

import {BrowserView,MobileView,TabletView, isMobileOnly, isTablet} from 'react-device-detect';

import momentStore from '../../../store/momentStore';
import pageStore from '../../../store/pageStore';

import i18n from "../../../i18n";

import { Chrono } from 'react-chrono';

const algoliasearch = require('algoliasearch');
var client = algoliasearch('HKB157K3KU', '357f2b37e5ef8c12f7b90877758ff663');

const viewportWidth =  window.innerWidth;
const viewportHeight = window.innerHeight;


let titleFontSize30, titleFontSize25, titleFontSize22, titleFontSize20, titleFontSize19, titleFontSize18, titleFontSize17, titleFontSize16, titleFontSize15, titleFontSize14, titleFontSize13, titleFontSize;

if (viewportWidth > 1400)
{
   titleFontSize = 40;
   titleFontSize30 = 30;
   titleFontSize25 = 25;
   titleFontSize22 = 22;
   titleFontSize20 = 20;
   titleFontSize19 = 19;
   titleFontSize18 = 18;
   titleFontSize17 = 17;
   titleFontSize16 = 16;
   titleFontSize15 = 15;
   titleFontSize14 = 14;
   titleFontSize13 = 13;
}
else if (viewportWidth > 1200)
{
   titleFontSize = 35;
   titleFontSize30 = 26;
   titleFontSize25 = 22;
   titleFontSize22 = 20;
   titleFontSize20 = 19;
   titleFontSize19 = 18;
   titleFontSize18 = 17;
   titleFontSize17 = 16;
   titleFontSize16 = 15;
   titleFontSize15 = 14;
   titleFontSize14 = 13;
   titleFontSize13 = 12;
}
else
{
   titleFontSize = 30;
   titleFontSize30 = 24;
   titleFontSize25 = 19;
   titleFontSize22 = 17;
   titleFontSize20 = 18;
   titleFontSize19 = 17;
   titleFontSize18 = 16;
   titleFontSize17 = 15;
   titleFontSize16 = 14;
   titleFontSize15 = 13;
   titleFontSize14 = 12;
   titleFontSize13 = 11;
}

function truncate(text, maxLength) {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
}

function replaceWithBr(s, maxl) {

  let txt = truncate(s, maxl);

  return txt.replace(/\*\*\*(.*?)\*\*\*/g, '<b><i>$1</i></b>')
          .replace(/\*\*(.*?)\*\*/g, '<i>$1</i>')
          .replace(/\*(.*?)\*/g, '<b>$1</b>')
}

function formatDateObject(dateObj, options = {}) {
  if (!dateObj || !dateObj.value) return "";
  const { precision, value, era, approximate, startTime } = dateObj;
  const prefix = approximate ? "vers " : "";
  const t = startTime ? ` ${startTime}` : "";

  switch (precision) {
    case "millennium":
      return `${prefix}${value}ᵉ millénaire ${era === "BC" ? "av. J.-C." : ""}`;
    case "century":
      return `${prefix}${value}ᵉ siècle ${era === "BC" ? "av. J.-C." : ""}`;
    case "decade":
      return `${prefix}années ${value} ${era === "BC" ? "av. J.-C." : ""}`;
    case "year":
      return `${prefix}${value} ${era === "BC" ? "av. J.-C." : ""}`;
    case "year-month": {
      const [year, month] = value.split("-");
      return `${prefix}${month}/${year}`;
    }
    case "full-date":
      return `${prefix}${new Date(value).toLocaleDateString("fr-FR", {
        year: "numeric",
        month: "long",
        day: "numeric"
      })}${t}`;
    default:
      return `${prefix}${value}`;
  }
}


function toTimestamp(dateObj) {
  if (!dateObj || !dateObj.value) return null;

  const { precision, value, era, startTime } = dateObj;

  let year = 0;
  let month = 0;
  let day = 1;
  let hour = 0;
  let minute = 0;

  // Si startTime est défini au format "hh:mm"
  if (startTime && typeof startTime === 'string') {
    const [h, m] = startTime.split(":").map(Number);
    hour = h || 0;
    minute = m || 0;
  }

  switch (precision) {
    case "millennium":
      year = (parseInt(value) - 1) * 1000 + 1;
      break;
    case "century":
      year = (parseInt(value) - 1) * 100 + 1;
      break;
    case "decade":
    case "year":
      year = parseInt(value);
      break;
    case "year-month": {
      const [y, m] = value.split("-").map(Number);
      year = y;
      month = m - 1; // JavaScript: mois entre 0 et 11
      break;
    }
    case "full-date": {
      const date = new Date(value);
      date.setHours(hour);
      date.setMinutes(minute);
      return date.getTime();
    }
    default:
      return null;
  }

  // Si on est en "BC", inverser la date
  if (era === "BC") {
    year = -year + 1;
  }

  // Créer l'objet Date
  const date = new Date(Date.UTC(year, month, day, hour, minute));
  return date.getTime();
}



function parseDates(item) {
  let res = '';
  if (!item.dates.startAndEndDate)
  {
    res = `${formatDateObject(item.dates.start)}`;
  }
  else
  {
     if (item.dates.ongoing)
     {
        res = `${formatDateObject(item.dates.start)} - ${i18n.t('Present')}`;
     }
     else
     {
        res = `${formatDateObject(item.dates.start)} - ${formatDateObject(item.dates.end)}`;
     }
  }

  return res;

}



class PopMoments extends Component {
  constructor(props) {
    super(props);
    this.popupRef = createRef();

    const items = [
    {
      title: 'May 1940',
      date: new Date(),
      cardTitle: 'Dunkirk',
      url: 'https://www.debyoo.com/',
      cardSubtitle:
        'Men of the British Expeditionary Force (BEF) wade out to a destroyer...',
      cardDetailedText:
        'Men of the British Expeditionary Force (BEF) wade out to a destroyer during the evacuation from Dunkirk.',
      media: {
        type: 'IMAGE',
        source: {
          url: 'https://media.tacdn.com/media/attractions-splice-spp-674x446/07/bd/6f/17.jpg',
        },
        name: "New York City"
      },
      items: [{ cardTitle: 'Sub-event 1', url: 'https://www.debyoo.com/', }, { cardTitle: 'Sub-event 2' }]
    },
   ];

    this.state = {
      followed: props.followed,
      status: 'init',
     hasInteracted: false,
     items: [],
     processing: false,
     showInnerDiv: false,
    };
  }

  componentDidMount() {
    this.loadMoments();

    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  loadMoments() {

    var index = client.initIndex('Story');



    index
    .search('*',
    {
      page: 0,
      filters: `master_story_id:${this.props.selectedObject.objectID} AND specialtype:moment`,
      hitsPerPage: 200
    })
    .then(({ hits, nbPages, page, nbHits }) =>
      {



            if (nbHits > 0)
            {

                const newArray = hits.map((obj, index) => ({
                  objectID: obj.objectID,
                  index: index,
                  story_public_id: obj.story_public_id,
                  title: parseDates(obj),
                  id: obj.objectID,
                  moment_format: obj.moment_format,
                  item_title: obj.title,
                  description: obj.description,
                  medias: obj.medias,
                  timestamp: toTimestamp(obj.dates.start)
                }))

              //  alert(JSON.stringify(newArray[0].item_title));

                 this.setState({
                   status: 'completed',
                   items: newArray.sort((a, b) => a.timestamp - b.timestamp),
                 });

                if (isMobileOnly)
                {
                     setTimeout(() => {

                            const elements = document.querySelectorAll('[class*="CardTitleSemantic"]');

                            elements.forEach(el => {
                              el.style.color = '#0b49ff';
                              el.style.fontSize = '15px';
                            });

                            const elementsH = document.querySelectorAll('[class*="TimelineCardHeader"]');

                            elementsH.forEach(el => {
                              el.style.height = '18px';
                            });


                            const elementsW = document.querySelectorAll('[class*="TimelineItemContentWrapper"]');

                            elementsW.forEach(el => {
                              el.style.padding= '8px';
                              el.style.border = 'none';
                              el.style.boxShadow = 'none'
                            });


                            const elementsCW = document.querySelectorAll('[class*="TimelineCardContentWrapper"]');

                            elementsCW.forEach(el => {
                              el.style.border = 'none';
                              el.style.boxShadow = 'none'
                            });

                            const elementsCCW = document.querySelectorAll('[class*="card-content-wrapper"]');

                            elementsCCW.forEach(el => {
                              el.style.border = 'none';
                              el.style.boxShadow = 'none'
                            });







                     }, 100);
                 }



            }
            else
            {
              this.setState({
                status: 'completed',
                items: []
              });
            }



     });

  }

  handleClickOutside = (event) => {
    if (this.popupRef.current && !this.popupRef.current.contains(event.target)) {
      this.closePopup(); // Call the function to close the popup
    }
  }

  closePopup() {
    this.setState({
      showInnerDiv: false
    });

    setTimeout(() => {
      this.props.onClose();
    }, 400);

  }

  displayInnerDiv() {

    this.setState({
      showInnerDiv: true,
      followed: this.props.followed
    });
  }


  onItemSelected = (item) => {
    if (!this.state.hasInteracted)
    {


       this.setState({
         hasInteracted: true
       });

       return;
    }



    const _item = this.state.items.find(obj => obj.index === item.index);

    momentStore.getState().setSelectedItem(_item);



    setTimeout(() => {
      this.props.onClose();

      this.closePopup();

    //  const selected = momentStore.getState().selectedItem;

    //  alert(JSON.stringify(selected))

      const pageType = pageStore.getState().currentPage;

      if (pageType === "Full")
      {
         momentStore.getState().triggerHandler();
      }
      else if (pageType === "Landing")
      {
         pageStore.getState().triggerHandler();


      }
      else
      {
          window.location = `/p/${_item.story_public_id}?a=in&m=${item.index}&source=home`;
      }



    }, 100);

    //  alert(JSON.stringify(_item));

  //  this.props.goToSelectedMoment(_item, item.index);

    //alert(JSON.stringify(item))
  }


  render() {

    const customDarkTheme = {
       // Base colors
       primary: '#111',
       secondary: '#0b49ff',
       textColor: '#111',
       titleColor: '#0b49ff',
       titleColorActive: '#fff',
       iconBackgroundColor: '#fff',
       shadowColor: 'rgba(0, 0, 0, 0.6)',
       glowColor: 'rgba(237, 137, 54,1)',
    };

    return (
      <div style={{position: 'fixed', zIndex: 99, width: '100%', height: '100%', top: 0, left: 0, bottom: 0, display: 'flex',
                               justifyContent: 'center', alignItems: 'center',backgroundColor: 'rgba(0,0,0,0.7)'}}>



             {isMobileOnly &&
                     <div className="scroll-area"
                             style={{
                               width: '100%',
                               maxHeight: "100vh",
                               overflowY: "auto",
                               position: "relative",
                               zIndex: 0,
                             }}
                           >

                       <div style={{width: '100%', minHeight: viewportHeight+'px',}}>

                            <AnimatePresence>

                                {this.state.showInnerDiv && (

                                    <motion.div ref={this.popupRef}
                                           initial={{ scale: 0, opacity: 0 }}
                                           exit={{ scale: 0, opacity: 0 }}
                                           whileInView={{ scale: 1, opacity: 1 }}
                                           transition={{ duration: 0.4, ease: 'easeOut' }}
                                           style={{position: 'relative', width: '100%',
                                                 minHeight: viewportHeight*1.1+'px',
                                                 margin: 'auto', marginTop: '20px', marginBottom: '40px',
                                                 backgroundColor: 'white',
                                                 borderRadius: '8px',}}>

                                           <div onClick={this.closePopup.bind(this)} style={{position: 'absolute', cursor: 'pointer', right: 10, top: 30, zIndex: 3}}>
                                              <img src={'/img/cancel_icon_grey.png'} style={{width: '36px', height: '36px'}}/>
                                           </div>


                                           <div style={{padding: '10px'}}>



                                                   <div style={{clear: 'both', height: '30px'}}/>


                                                   <div style={{display: 'flex', flexDirection: 'row'}}>
                                                       <div style={{paddingRight: '10px'}}>
                                                         <View style={{height: '60px', justifyContent: 'center'}}>
                                                           <Image source={{uri: '/img/storrypage_thumb.png'}} style={{width: '36px', height: '36px'}}/>
                                                         </View>
                                                       </div>
                                                       <div style={{paddingLeft: '0px', paddingRight: '10px'}}>
                                                         <View style={{height: '60px', justifyContent: 'center'}}>
                                                           <Text style={{color: '#56626e', fontWeight: 'bold', fontSize: titleFontSize25+'px'}}>{i18n.t('Moments_of_this_storrypage')}</Text>
                                                         </View>
                                                       </div>
                                                   </div>


                                                   <div style={{clear: 'both', height: '30px'}}/>

                                                   {this.state.status === 'init' &&
                                                    <div style={{width: '100%', margin: 'auto', color: '#111'}}>
                                                        <View style={{width: '94%', margin: 'auto', height: '300px', alignItems: 'center', justifyContent: 'center'}}>

                                                              <ActivityIndicator  animating={true} color="#555" />

                                                        </View>
                                                    </div>
                                                  }


                                                  {this.state.status === 'completed' && this.state.items.length === 0 &&
                                                   <div style={{width: '94%', margin: 'auto', color: '#56626e'}}>

                                                       <div style={{textAlign: 'left', fontSize: titleFontSize22+'px', marginTop: '100px'}}>
                                                         {i18n.t('No_moments')}
                                                       </div>

                                                       {!this.state.followed && pageStore.getState().currentPage !== 'Home' &&
                                                         <div style={{textAlign: 'left', fontSize: titleFontSize20+'px', marginTop: '30px'}}>
                                                           {i18n.t('Not_following_moments_message')}
                                                         </div>
                                                       }

                                                       {this.state.followed && pageStore.getState().currentPage !== 'Home' &&
                                                         <div style={{textAlign: 'left', fontSize: titleFontSize20+'px', marginTop: '30px'}}>
                                                           {i18n.t('Following_moments_message')}
                                                         </div>
                                                       }

                                                  </div>
                                                  }



                                                  {this.state.status === 'completed' && this.state.items.length > 0 &&
                                                    <div style={{width: '100%', marginLeft: '-30px'}}>
                                                       <Chrono disableToolbar={true} cardLess={false} timelinePointShape={'square'} timelinePointDimension={36} borderLessCards={true}
                                                              theme={customDarkTheme} cardHeight={null} disableAutoScrollOnClick={true} lineWidth={1}
                                                               onItemSelected={this.onItemSelected} items={this.state.items} mode="VERTICAL">


                                                                {this.state.items.map((item, index) => (
                                                                  <div key={index}>
                                                                     {item.moment_format === 'Text' &&
                                                                       <div style={{height: '60px'}}>
                                                                           <View style={{width: '100%', height: '60px', justifyContent: 'center'}}>
                                                                                {item.item_title !== '' &&
                                                                                   <Text numberOfLines={1} style={{marginBottom: '5px', textAlign: 'left', fontWeight: 'bold', color: '#111', fontSize: '16px'}}>
                                                                                     {item.item_title}
                                                                                  </Text>
                                                                                 }
                                                                                {item.item_title === '' && <div dangerouslySetInnerHTML={{__html: replaceWithBr(item.description, 70)}} style={{fontSize: '15px', lineHeight: '17px', color: '#111'}}></div>}
                                                                           </View>
                                                                       </div>
                                                                     }
                                                                     {item.moment_format === 'Audio' &&
                                                                       <div style={{height: '100px', display: 'flex', flexDirection: 'row'}}>
                                                                           <div style={{height: '100px', marginLeft: '10px'}}>
                                                                               <View style={{height: '100px', justifyContent: 'center'}}>
                                                                                      <div style={{width: '100px', height: '100px', backgroundColor: '#bbb', border: '1px solid #ccc', overflow: 'hidden'}}>
                                                                                          <picture>
                                                                                             <source srcSet={item.medias.audio.cover_url.replace(/\.(jpg|jpeg|png)$/i, '.webp')} type="image/webp" />
                                                                                             <img src={item.medias.audio.cover_url} style={{width: '100px', height: '100px', objectFit: 'cover'}} />
                                                                                          </picture>
                                                                                      </div>
                                                                               </View>
                                                                            </div>

                                                                            <div style={{height: '100px', marginLeft: '10px'}}>
                                                                                <View style={{height: '100px', justifyContent: 'center'}}>
                                                                                     {item.item_title !== '' &&
                                                                                        <Text numberOfLines={1} style={{marginBottom: '5px', textAlign: 'left', fontWeight: 'bold', color: '#111', fontSize: '16px'}}>
                                                                                          {item.item_title}
                                                                                       </Text>
                                                                                      }
                                                                                     {item.item_title === '' && <div dangerouslySetInnerHTML={{__html: replaceWithBr(item.description, 70)}} style={{fontSize: '15px', lineHeight: '17px', color: '#111'}}></div>}
                                                                                </View>
                                                                            </div>
                                                                       </div>
                                                                     }
                                                                     {item.moment_format === 'Photo' &&
                                                                     <div style={{height: '100px', display: 'flex', flexDirection: 'row'}}>
                                                                         <div style={{height: '100px', marginLeft: '10px'}}>
                                                                             <View style={{height: '100px', justifyContent: 'center'}}>
                                                                                    <div style={{width: '60px', height: '60px', backgroundColor: '#bbb', border: '1px solid #ccc', overflow: 'hidden'}}>
                                                                                        <picture>
                                                                                           <source srcSet={item.medias.photos[0].replace(/\.(jpg|jpeg|png)$/i, '.webp')} type="image/webp" />
                                                                                           <img src={item.medias.photos[0]} style={{width: '60px', height: '60px', objectFit: 'cover'}} />
                                                                                        </picture>
                                                                                    </div>
                                                                             </View>
                                                                          </div>

                                                                          <div style={{height: '100px', marginLeft: '10px'}}>
                                                                              <View style={{height: '100px', justifyContent: 'center'}}>
                                                                                   {item.item_title !== '' &&
                                                                                      <Text numberOfLines={3} style={{marginBottom: '5px', textAlign: 'left', fontWeight: 'bold', color: '#111', fontSize: '14px'}}>
                                                                                        {item.item_title}
                                                                                     </Text>
                                                                                    }
                                                                                   {item.item_title === '' && <div dangerouslySetInnerHTML={{__html: replaceWithBr(item.description, 70)}} style={{fontSize: '15px', lineHeight: '17px', color: '#111'}}></div>}
                                                                              </View>
                                                                          </div>
                                                                     </div>
                                                                     }
                                                                     {item.moment_format === 'Video' &&
                                                                       <div style={{height: item.medias.video.metadata.orientation === 'portrait' ? '100px':100*9/16+'px', display: 'flex', flexDirection: 'row'}}>
                                                                           <div style={{height: item.medias.video.metadata.orientation === 'portrait' ? '100px':100*9/16+'px', marginLeft: '0px'}}>
                                                                               <View style={{height: item.medias.video.metadata.orientation === 'portrait' ? '100px':100*9/16+'px', justifyContent: 'center'}}>
                                                                                  {item.medias.video.metadata.orientation === 'portrait' &&
                                                                                      <div style={{width: 100*9/16+'px', height: '100px', backgroundColor: '#bbb', border: '1px solid #ccc', overflow: 'hidden'}}>
                                                                                         <picture>
                                                                                            <source srcSet={item.medias.video.thumbnail_url.replace(/\.(jpg|jpeg|png)$/i, '.webp')} type="image/webp" />
                                                                                            <img src={item.medias.video.thumbnail_url} style={{width: 100*9/16+'px', height: '100px', objectFit: 'cover'}} />
                                                                                         </picture>
                                                                                      </div>
                                                                                   }
                                                                                  {item.medias.video.metadata.orientation === 'landscape' &&
                                                                                     <div style={{width: '60px', height: 100*9/16+'px', backgroundColor: '#bbb', border: '1px solid #ccc', overflow: 'hidden'}}>
                                                                                         <picture>
                                                                                            <source srcSet={item.medias.video.thumbnail_url.replace(/\.(jpg|jpeg|png)$/i, '.webp')} type="image/webp" />
                                                                                            <img src={item.medias.video.thumbnail_url} style={{width: '60px', height: 100*9/16+'px', objectFit: 'cover'}} />
                                                                                         </picture>
                                                                                     </div>
                                                                                   }
                                                                                  {item.medias.video.metadata.orientation === 'square' &&
                                                                                      <div style={{width: '60px', height: '100px', backgroundColor: '#bbb', border: '1px solid #ccc', overflow: 'hidden'}}>
                                                                                          <picture>
                                                                                             <source srcSet={item.medias.video.thumbnail_url.replace(/\.(jpg|jpeg|png)$/i, '.webp')} type="image/webp" />
                                                                                             <img src={item.medias.video.thumbnail_url} style={{width: '60px', height: '100px', objectFit: 'cover'}} />
                                                                                          </picture>
                                                                                      </div>
                                                                                   }
                                                                               </View>
                                                                            </div>

                                                                            <div style={{height: item.medias.video.metadata.orientation === 'portrait' ? '100px':100*9/16+'px', marginLeft: '10px'}}>
                                                                                <View style={{height: item.medias.video.metadata.orientation === 'portrait' ? '100px':100*9/16+'px', justifyContent: 'center'}}>
                                                                                     {item.item_title !== '' &&
                                                                                        <Text numberOfLines={3} style={{marginBottom: '5px', textAlign: 'left', fontWeight: 'bold', color: '#111', fontSize: '14px'}}>
                                                                                          {item.item_title}
                                                                                       </Text>
                                                                                      }
                                                                                     {item.item_title === '' && <div dangerouslySetInnerHTML={{__html: replaceWithBr(item.description, 70)}} style={{fontSize: '14px', lineHeight: '16px', color: '#111'}}></div>}
                                                                                </View>
                                                                            </div>
                                                                       </div>
                                                                     }
                                                                  </div>
                                                                ))}



                                                              <div className="chrono-icons">
                                                                {this.state.items.map((item, index) => (
                                                                  <div key={index}>
                                                                     {item.moment_format === 'Text' && <img src="/img/text_icon.png" style={{width: '36px', height: '36px'}}/>}
                                                                     {item.moment_format === 'Audio' && <img src="/img/audio_icon.png" style={{width: '36px', height: '36px'}}/>}
                                                                     {item.moment_format === 'Photo' && <img src="/img/photo_icon.png" style={{width: '36px', height: '36px'}}/>}
                                                                     {item.moment_format === 'Video' && <img src="/img/video_icon.png" style={{width: '36px', height: '36px'}}/>}
                                                                  </div>
                                                                ))}
                                                              </div>



                                                      </Chrono>
                                                    </div>
                                                  }



                                            </div>

                                     </motion.div>
                                 )}

                             </AnimatePresence>

                          </div>

                      </div>
                  }




                  {!isMobileOnly &&
                          <div className="scroll-area"
                                  style={{
                                    width: '100%',
                                    maxHeight: "100vh",
                                    overflowY: "auto",
                                    position: "relative",
                                    zIndex: 0,
                                  }}
                                >

                            <div style={{width: '100%', minHeight: viewportHeight+'px',}}>

                                 <AnimatePresence>

                                     {this.state.showInnerDiv && (

                                         <motion.div ref={this.popupRef}
                                                initial={{ scale: 0, opacity: 0 }}
                                                exit={{ scale: 0, opacity: 0 }}
                                                whileInView={{ scale: 1, opacity: 1 }}
                                                transition={{ duration: 0.4, ease: 'easeOut' }}
                                                style={{position: 'relative', width: '900px',
                                                      minHeight: viewportHeight*1.1+'px',
                                                      margin: 'auto', marginTop: '20px', marginBottom: '40px',
                                                      backgroundColor: 'white',
                                                      borderRadius: '8px',}}>

                                                {!isMobileOnly && !isTablet &&
                                                  <div onClick={this.closePopup.bind(this)} style={{position: 'absolute', cursor: 'pointer', right: 10, top: 10, zIndex: 3}}>
                                                     <img src={'/img/cancel_icon_grey.png'} style={{width: '40px', height: '40px'}}/>
                                                  </div>
                                                }
                                                {isTablet &&
                                                  <div onClick={this.closePopup.bind(this)} style={{position: 'absolute', cursor: 'pointer', right: 20, top: 30, zIndex: 3}}>
                                                     <img src={'/img/cancel_icon_grey.png'} style={{width: '36px', height: '36px'}}/>
                                                  </div>
                                                }


                                                <div style={{padding: '40px'}}>


                                                        <div style={{display: 'flex', flexDirection: 'row'}}>
                                                            <div style={{paddingRight: '10px'}}>
                                                              <View style={{height: '60px', justifyContent: 'center'}}>
                                                                <Image source={{uri: '/img/storrypage_thumb.png'}} style={{width: '36px', height: '36px'}}/>
                                                              </View>
                                                            </div>
                                                            <div style={{paddingLeft: '0px', paddingRight: '10px'}}>
                                                              <View style={{height: '60px', justifyContent: 'center'}}>
                                                                <Text style={{color: '#56626e', fontWeight: 'bold', fontSize: titleFontSize25+'px'}}>{i18n.t('Moments_of_this_storrypage')}</Text>
                                                              </View>
                                                            </div>
                                                        </div>


                                                        <div style={{clear: 'both', height: '30px'}}/>

                                                        {this.state.status === 'init' &&
                                                         <div style={{width: '820px', margin: 'auto', color: '#111'}}>
                                                             <View style={{width: 840+'px', height: '300px', alignItems: 'center', justifyContent: 'center'}}>

                                                                   <ActivityIndicator  animating={true} color="#555" />

                                                             </View>
                                                         </div>
                                                       }


                                                       {this.state.status === 'completed' && this.state.items.length === 0 &&
                                                        <div style={{width: '820px', color: '#56626e'}}>

                                                            <div style={{textAlign: 'left', fontSize: titleFontSize22+'px', marginTop: '100px'}}>
                                                              {i18n.t('No_moments')}
                                                            </div>

                                                            {!this.state.followed && pageStore.getState().currentPage !== 'Home' &&
                                                              <div style={{textAlign: 'left', fontSize: titleFontSize20+'px', marginTop: '30px'}}>
                                                                {i18n.t('Not_following_moments_message')}
                                                              </div>
                                                            }

                                                            {this.state.followed && pageStore.getState().currentPage !== 'Home' &&
                                                              <div style={{textAlign: 'left', fontSize: titleFontSize20+'px', marginTop: '30px'}}>
                                                                {i18n.t('Following_moments_message')}
                                                              </div>
                                                            }

                                                       </div>
                                                       }



                                                       {this.state.status === 'completed' && this.state.items.length > 0 &&
                                                         <div style={{width: '820px', margin: 'auto'}}>
                                                            <Chrono disableToolbar={true} cardLess={false} timelinePointShape={'circle'} timelinePointDimension={50}
                                                                   theme={customDarkTheme} cardHeight={null} disableAutoScrollOnClick={true}
                                                                   highlightCardsOnHover onItemSelected={this.onItemSelected} items={this.state.items} mode="VERTICAL_ALTERNATING">




                                                                     {this.state.items.map((item, index) => (
                                                                       <div key={index}>
                                                                          {item.moment_format === 'Text' &&
                                                                            <div style={{height: '60px'}}>
                                                                                <View style={{width: '100%', height: '60px', justifyContent: 'center'}}>
                                                                                     {item.item_title !== '' &&
                                                                                        <Text numberOfLines={1} style={{marginBottom: '5px', textAlign: 'left', fontWeight: 'bold', color: '#111', fontSize: '16px'}}>
                                                                                          {item.item_title}
                                                                                       </Text>
                                                                                      }
                                                                                     {item.item_title === '' && <div dangerouslySetInnerHTML={{__html: replaceWithBr(item.description, 70)}} style={{fontSize: '15px', lineHeight: '17px', color: '#111'}}></div>}
                                                                                </View>
                                                                            </div>
                                                                          }
                                                                          {item.moment_format === 'Audio' &&
                                                                            <div style={{height: '100px', display: 'flex', flexDirection: 'row'}}>
                                                                                <div style={{height: '100px', marginLeft: '10px'}}>
                                                                                    <View style={{height: '100px', justifyContent: 'center'}}>
                                                                                           <div style={{width: '100px', height: '100px', backgroundColor: '#bbb', border: '1px solid #ccc', overflow: 'hidden'}}>
                                                                                               <picture>
                                                                                                  <source srcSet={item.medias.audio.cover_url.replace(/\.(jpg|jpeg|png)$/i, '.webp')} type="image/webp" />
                                                                                                  <img src={item.medias.audio.cover_url} style={{width: '100px', height: '100px', objectFit: 'cover'}} />
                                                                                               </picture>
                                                                                           </div>
                                                                                    </View>
                                                                                 </div>

                                                                                 <div style={{height: '100px', marginLeft: '10px'}}>
                                                                                     <View style={{height: '100px', justifyContent: 'center'}}>
                                                                                          {item.item_title !== '' &&
                                                                                             <Text numberOfLines={1} style={{marginBottom: '5px', textAlign: 'left', fontWeight: 'bold', color: '#111', fontSize: '16px'}}>
                                                                                               {item.item_title}
                                                                                            </Text>
                                                                                           }
                                                                                          {item.item_title === '' && <div dangerouslySetInnerHTML={{__html: replaceWithBr(item.description, 70)}} style={{fontSize: '15px', lineHeight: '17px', color: '#111'}}></div>}
                                                                                     </View>
                                                                                 </div>
                                                                            </div>
                                                                          }
                                                                          {item.moment_format === 'Photo' &&
                                                                          <div style={{height: '100px', display: 'flex', flexDirection: 'row'}}>
                                                                              <div style={{height: '100px', marginLeft: '10px'}}>
                                                                                  <View style={{height: '100px', justifyContent: 'center'}}>
                                                                                         <div style={{width: '100px', height: '100px', backgroundColor: '#bbb', border: '1px solid #ccc', overflow: 'hidden'}}>
                                                                                             <picture>
                                                                                                <source srcSet={item.medias.photos[0].replace(/\.(jpg|jpeg|png)$/i, '.webp')} type="image/webp" />
                                                                                                <img src={item.medias.photos[0]} style={{width: '100px', height: '100px', objectFit: 'cover'}} />
                                                                                             </picture>
                                                                                         </div>
                                                                                  </View>
                                                                               </div>

                                                                               <div style={{height: '100px', marginLeft: '10px'}}>
                                                                                   <View style={{height: '100px', justifyContent: 'center'}}>
                                                                                        {item.item_title !== '' &&
                                                                                           <Text numberOfLines={3} style={{marginBottom: '5px', textAlign: 'left', fontWeight: 'bold', color: '#111', fontSize: '16px'}}>
                                                                                             {item.item_title}
                                                                                          </Text>
                                                                                         }
                                                                                        {item.item_title === '' && <div dangerouslySetInnerHTML={{__html: replaceWithBr(item.description, 70)}} style={{fontSize: '15px', lineHeight: '17px', color: '#111'}}></div>}
                                                                                   </View>
                                                                               </div>
                                                                          </div>
                                                                          }
                                                                          {item.moment_format === 'Video' &&
                                                                            <div style={{height: item.medias.video.metadata.orientation === 'portrait' ? '100px':100*9/16+'px', display: 'flex', flexDirection: 'row'}}>
                                                                                <div style={{height: item.medias.video.metadata.orientation === 'portrait' ? '100px':100*9/16+'px', marginLeft: '10px'}}>
                                                                                    <View style={{height: item.medias.video.metadata.orientation === 'portrait' ? '100px':100*9/16+'px', justifyContent: 'center'}}>
                                                                                       {item.medias.video.metadata.orientation === 'portrait' &&
                                                                                           <div style={{width: 100*9/16+'px', height: '100px', backgroundColor: '#bbb', border: '1px solid #ccc', overflow: 'hidden'}}>
                                                                                              <picture>
                                                                                                 <source srcSet={item.medias.video.thumbnail_url.replace(/\.(jpg|jpeg|png)$/i, '.webp')} type="image/webp" />
                                                                                                 <img src={item.medias.video.thumbnail_url} style={{width: 100*9/16+'px', height: '100px', objectFit: 'cover'}} />
                                                                                              </picture>
                                                                                           </div>
                                                                                        }
                                                                                       {item.medias.video.metadata.orientation === 'landscape' &&
                                                                                          <div style={{width: '100px', height: 100*9/16+'px', backgroundColor: '#bbb', border: '1px solid #ccc', overflow: 'hidden'}}>
                                                                                              <picture>
                                                                                                 <source srcSet={item.medias.video.thumbnail_url.replace(/\.(jpg|jpeg|png)$/i, '.webp')} type="image/webp" />
                                                                                                 <img src={item.medias.video.thumbnail_url} style={{width: '100px', height: 100*9/16+'px', objectFit: 'cover'}} />
                                                                                              </picture>
                                                                                          </div>
                                                                                        }
                                                                                       {item.medias.video.metadata.orientation === 'square' &&
                                                                                           <div style={{width: '60px', height: '100px', backgroundColor: '#bbb', border: '1px solid #ccc', overflow: 'hidden'}}>
                                                                                               <picture>
                                                                                                  <source srcSet={item.medias.video.thumbnail_url.replace(/\.(jpg|jpeg|png)$/i, '.webp')} type="image/webp" />
                                                                                                  <img src={item.medias.video.thumbnail_url} style={{width: '100px', height: '100px', objectFit: 'cover'}} />
                                                                                               </picture>
                                                                                           </div>
                                                                                        }
                                                                                    </View>
                                                                                 </div>

                                                                                 <div style={{height: item.medias.video.metadata.orientation === 'portrait' ? '100px':100*9/16+'px', marginLeft: '10px'}}>
                                                                                     <View style={{height: item.medias.video.metadata.orientation === 'portrait' ? '100px':100*9/16+'px', justifyContent: 'center'}}>
                                                                                          {item.item_title !== '' &&
                                                                                             <Text numberOfLines={3} style={{marginBottom: '5px', textAlign: 'left', fontWeight: 'bold', color: '#111', fontSize: '16px'}}>
                                                                                               {item.item_title}
                                                                                            </Text>
                                                                                           }
                                                                                          {item.item_title === '' && <div dangerouslySetInnerHTML={{__html: replaceWithBr(item.description, 70)}} style={{fontSize: '15px', lineHeight: '17px', color: '#111'}}></div>}
                                                                                     </View>
                                                                                 </div>
                                                                            </div>
                                                                          }
                                                                       </div>
                                                                     ))}



                                                                   <div className="chrono-icons">
                                                                     {this.state.items.map((item, index) => (
                                                                       <div key={index}>
                                                                          {item.moment_format === 'Text' && <img src="/img/text_icon.png" style={{width: '50px', height: '50px'}}/>}
                                                                          {item.moment_format === 'Audio' && <img src="/img/audio_icon.png" style={{width: '50px', height: '50px'}}/>}
                                                                          {item.moment_format === 'Photo' && <img src="/img/photo_icon.png" style={{width: '50px', height: '50px'}}/>}
                                                                          {item.moment_format === 'Video' && <img src="/img/video_icon.png" style={{width: '50px', height: '50px'}}/>}
                                                                       </div>
                                                                     ))}
                                                                   </div>



                                                           </Chrono>
                                                         </div>
                                                       }



                                                 </div>

                                          </motion.div>
                                      )}

                                  </AnimatePresence>

                               </div>

                           </div>
                       }

       </div>
    );
  }
}

export default PopMoments;
